import styled from 'styled-components'

export const BuildInfo = styled.div`
  position: fixed;
  bottom: 10px;
  left: 10px;
  color: #303030;
  font-size: 0.8em;
  text-align: left;
  display: flex;
  flex-direction: row;
  width: 315px;
  padding: 2px;

  .revision-specs {
    width: 90%;
  }

  .revision-btn {
    width: 10%;
    .icon-f-cross {
      top: 0;
    }
  }
`
